import { Div } from "@hopper-ui/components";
import { StaggeredAnimation, StaggeredAnimationItem, SuggestedPrompt, useCreateConversation, useIsCreateConversationMutating, useSharedTranslation } from "@workleap-ai/shared";
import { useCallback } from "react";

const MAX_SUGGESTED_PROMPTS = 3;

export function SuggestedPrompts() {
    const { tShared } = useSharedTranslation();
    const { createConversation } = useCreateConversation();
    const isMutating = useIsCreateConversationMutating();

    const prompts = Array.from({ length: MAX_SUGGESTED_PROMPTS }, (_, index) => {
        return tShared(`suggestedPrompt${index + 1}`);
    });

    const handlePress = useCallback((prompt: string) => {
        createConversation(prompt, { isDefaultSuggestion: true });
    }, [createConversation]);

    return (
        <Div
            marginX="auto"
            paddingX={{
                base: "core_0",
                md: "inset-md"
            }}
            UNSAFE_maxWidth="var(--wai-page-max-width)"
            width="100%"
        >
            <StaggeredAnimation
                animation="wai-reveal-left-to-right"
                display="flex"
                flexDirection="column"
                gap="inline-sm"
                initialDelay={480}
                delayIncrement={90}
            >
                {prompts.map(prompt => (
                    <StaggeredAnimationItem key={prompt}>
                        <SuggestedPrompt
                            text={prompt}
                            onPress={() => handlePress(prompt)}
                            isDisabled={isMutating}
                            size={{ base: "sm", sm: "md" }}
                        />
                    </StaggeredAnimationItem>
                ))}
            </StaggeredAnimation>
        </Div>
    );
}
